import { useIsRTL } from '@sas/nova-commons/locale';
import { useDrag } from '@sas/nova-commons/hooks/useDrag';
export function useResizable(props) {
    const { ref, onResize } = props;
    const isRTL = useIsRTL();
    /**
     * Calculate the dimensions given the mouse x/y offset
     *
     * @param position {deltaX:number, deltaY:number}
     */
    const calculateNewSize = (position) => {
        const node = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!node)
            return;
        const currentDimensions = {
            width: parseInt(node.style.width),
            height: parseInt(node.style.height),
        };
        const newDimensions = {
            width: isRTL
                ? currentDimensions.width - position.deltaX
                : currentDimensions.width + position.deltaX,
            height: currentDimensions.height + position.deltaY,
        };
        // make sure we don't exceed potential min/max style settings
        if (!isNaN(parseFloat(node.style.minWidth))) {
            newDimensions.width = Math.max(newDimensions.width, parseFloat(node.style.minWidth));
        }
        if (!isNaN(parseFloat(node.style.minHeight))) {
            newDimensions.height = Math.max(newDimensions.height, parseFloat(node.style.minHeight));
        }
        if (!isNaN(parseFloat(node.style.maxWidth))) {
            newDimensions.width = Math.min(newDimensions.width, parseFloat(node.style.maxWidth));
        }
        if (!isNaN(parseFloat(node.style.maxHeight))) {
            newDimensions.height = Math.min(newDimensions.height, parseFloat(node.style.maxHeight));
        }
        return newDimensions;
    };
    const { startDrag, abortDrag } = useDrag({
        onDrag: (_e, position) => {
            onResize(calculateNewSize(position));
        },
        onDragEnd: (_e, position) => {
            onResize(calculateNewSize(position));
        },
    });
    const onArrowKeyResize = (e) => {
        const stepSize = 5;
        switch (e.key) {
            case 'ArrowLeft':
                onResize(calculateNewSize({ deltaX: -stepSize, deltaY: 0 }));
                break;
            case 'ArrowRight':
                onResize(calculateNewSize({ deltaX: stepSize, deltaY: 0 }));
                break;
            case 'ArrowUp':
                onResize(calculateNewSize({ deltaX: 0, deltaY: -stepSize }));
                break;
            case 'ArrowDown':
                onResize(calculateNewSize({ deltaX: 0, deltaY: stepSize }));
                break;
        }
    };
    return {
        startResize: (e) => {
            if (e.button !== 0)
                return; // only handle left-mouse button
            startDrag([e.clientX, e.clientY]);
            e.preventDefault();
        },
        onArrowKeyResize,
        abortResize: abortDrag,
    };
}
